import type { IUploadRepository } from '../repositories/IUploadRepository.js';
import type { UploadItem } from '../entities/UploadItem.js';

export function createUploadFileUseCase(deps: { uploadRepository: IUploadRepository }) {
  return (item: UploadItem, onProgress: (p: number) => void): Promise<string> =>
    deps.uploadRepository.uploadFile(item, onProgress);
}
